module.exports = new Promise((resolve, reject) => {
		window["_paperco_mfe_resolver_missions"] = { resolve, reject };
		const script = document.createElement("script");
		script.type = "module";
		script.async = true;
		script.innerHTML = `
			import("https://missions-web.paperstg.co/assets/remoteEntry.mjs")
				.then(remoteEntry => window["_paperco_mfe_resolver_missions"].resolve(remoteEntry))
				.catch(() => window["_paperco_mfe_resolver_missions"].reject("Failed to import _paperco_mfe_resolver_missions"));
		`
		document.head.appendChild(script);
	});